export const SidebarData = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "Getting Started",
    path: "/docs",
  },
  {
    title: "Avatar",
    path: "/docs/avatar",
  },
  {
    title: "Alert",
    path: "/docs/alert",
  },
  {
    title: "Badge",
    path: "/docs/badge",
  },
  {
    title: "Button",
    path: "/docs/button",
  },
  {
    title: "Card",
    path: "/docs/card",
  },
  {
    title: "Input",
    path: "/docs/input",
  },
  {
    title: "List",
    path: "/docs/list",
  },
  {
    title: "Modal",
    path: "/docs/modal",
  },
  {
    title: "Rating",
    path: "/docs/rating",
  },
];
